/*
 *  I04DIMPUISSCHAUDCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-05 16:57:19 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchDegreJourUnifie, fetchCoefficientG } from '@batical/data/src'
import { RDegreJourUnifie_Type, RCoefficientG_Type, I04DIMPUISSCHAUD_State } from '@batical/types/src'

function I04DIMPUISSCHAUD_docalcul(state: I04DIMPUISSCHAUD_State) {
  let selecteddju_uuid: RDegreJourUnifie_Type = fetchDegreJourUnifie(state.dju_uuid)
  let selectedcoeffG_uuid: RCoefficientG_Type = fetchCoefficientG(state.coeffG_uuid)
  if (state.in_choixCalculG === 0) {
    state.res_coeffG = selectedcoeffG_uuid.coeffG
  }
  state.res_intermittence =
    (selecteddju_uuid.average * 24 - state.in_nombreHeureReduit * state.in_nombreDegreAbaisse * state.in_nbJourChauffe) /
    (selecteddju_uuid.average * 24)
  state.res_deperdition =
    (state.in_surfaceHabitat * state.in_hauteur_plafond * state.res_coeffG * (state.in_tempConsigneAmbiance - state.in_tempExtBase)) / 1000

  state.res_puissanceTotale = state.res_deperdition / state.res_intermittence

  state.res_consoAnnuelleEstime =
    (24 *
      state.res_intermittence *
      state.in_surfaceHabitat *
      state.in_hauteur_plafond *
      state.res_coeffG *
      (selecteddju_uuid.average + state.in_nbJourChauffe * (state.in_tempConsigneAmbiance - 18))) /
    1000
  state.invalidated = false
  return state
}

export default I04DIMPUISSCHAUD_docalcul
